module.exports = __webpack_public_path__ + "img/wait-icon.10971ddb.svg";